import {
  NotificationGroup,
} from '@progress/kendo-react-notification';
import { FpNotification, FpNotificationData } from 'components/molecules/FpNotification';
import React, { useEffect, useState } from 'react';
import { useQueue } from 'react-use';
import { Fade } from '@progress/kendo-react-animation';

export interface FpNotificationGroupProps {
 notifications: FpNotificationData[]
 onClose: (id: string) => void
}

export function FpNotificationGroup(props: FpNotificationGroupProps) {
  // 自動クローズ予定のNotificatonIDのリスト
  const [beDeleteNotificationIds, setBeDeleteNotificationIds] = useState<string[]>([]);
  const {
    add, remove, first,
  } = useQueue<string>();

  useEffect(() => {
    const removeFirst = () => {
      const filterd = beDeleteNotificationIds.filter((id) => id !== first);
      setBeDeleteNotificationIds(filterd);
      remove();
    };
      // 追加されたのがsuccessでキューに入ってないなら、削除キューに入れる
    const lastNotification = props.notifications[props.notifications.length - 1];
    if (
      lastNotification
      && lastNotification.type?.style === 'success'
      && !beDeleteNotificationIds.includes(lastNotification.id)
    ) {
      const notificationId: string = lastNotification.id;
      add(notificationId);
      setBeDeleteNotificationIds([...beDeleteNotificationIds, notificationId]);
      setTimeout(() => {
        props.onClose(notificationId);
        removeFirst();
      }, 10000 /** 10秒 */);
    }
  }, [
    props,
    beDeleteNotificationIds,
    add,
    remove,
    first,
    setBeDeleteNotificationIds,
  ]);

  return (
    <NotificationGroup
      style={{
        right: 0,
        bottom: 0,
        padding: '16px',
        zIndex: 99,
      }}
    >
      <Fade
        enter
        exit
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          flexWrap: 'wrap-reverse',
          flexDirection: 'column',
        }}
      >
        { props.notifications.map((notification) => (
          <FpNotification
            {...notification}
            key={notification.id}
            onClose={props.onClose}
          />
        ))}
      </Fade>
    </NotificationGroup>
  );
}
